export const FETCH_POPUP_REQUEST = "FETCH_POPUP_REQUEST";
export const FETCH_POPUP_SUCCESS = 'FETCH_POPUP_SUCCESS';
export const FETCH_POPUP_FAILURE = 'FETCH_POPUP_FAILURE';

export const FETCH_ACTIVE_POPUP_REQUEST = "FETCH_ACTIVE_POPUP_REQUEST";

export const FETCH_PUBLISH_POPUP_REQUEST = "FETCH_PUBLISH_POPUP_REQUEST";

export const FETCH_CREATE_NEW_POPUP_REQUEST = 'FETCH_CREATE_NEW_POPUP_REQUEST';

export const FETCH_POPUP_ID_REQUEST ='FETCH_POPUP_ID_REQUEST';